import { useEffect, useState } from 'react';

const percentToDvh = (percent: number, vh: number) => vh ? `${(percent * vh) / 100}px` : `${percent}dvh`;

const setDvh = (theme: Record<string, any>) => {
  const vh = typeof window !== 'undefined' ? window.innerHeight : 0;

  return ({
  ...theme,
  sizes: {
    ...theme.sizes,
    dvh100: percentToDvh(100, vh),
    dvh90: percentToDvh(90, vh),
    dvh80: percentToDvh(80, vh),
    dvh70: percentToDvh(70, vh),
    dvh60: percentToDvh(60, vh),
    dvh50: percentToDvh(50, vh),
    dvh40: percentToDvh(40, vh),
    dvh30: percentToDvh(30, vh),
    dvh20: percentToDvh(20, vh),
    dvh10: percentToDvh(10, vh),
  },
})};

const useGetTheme = (initialTheme: Record<string, any>): Record<string, any> => {
  const [theme, setTheme] = useState(() => setDvh(initialTheme));

  useEffect(() => {
    const handleResize = () => {
      setTheme((prevTheme) => setDvh(prevTheme));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return theme;
};

export { useGetTheme };
